import { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [copied, setCopied] = useState('');

  const copy = (val, key) => {
    navigator.clipboard.writeText(val).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(''), 2000);
    });
  };

  return (
    <section id="contact" className="section-wrap">
      <div className="eyebrow-row">
        <div className="eyebrow-line" /><div className="eyebrow-txt">Get In Touch</div><div className="eyebrow-line" />
      </div>

      <div className="contact-grid">
        <div className="contact-left">
          <div className="avail-pill" style={{ marginBottom: 20 }}>
            <div className="avail-dot" /><span className="avail-txt">Open to opportunities</span>
          </div>
          <h2 className="contact-headline">Let's build something<br /><span>great together.</span></h2>
          <p className="contact-tagline">Whether you have a project in mind, a role that fits, or just want to talk tech — my inbox is always open. Based in Madurai, open to remote.</p>

          <div className="contact-cards">
            {[
              { icon: 'ti-mail',    label: 'Email',    val: 'vikramrajavc@gmail.com', key: 'email' },
              { icon: 'ti-phone',   label: 'Phone',    val: '+91 87606 36511',         key: 'phone' },
              { icon: 'ti-map-pin', label: 'Location', val: 'Madurai, Tamil Nadu, India', key: null },
              { icon: 'ti-briefcase', label: 'Availability', val: 'Open to remote', key: null },
            ].map(c => (
              <div key={c.label} className="ccard">
                <div className="ccard-icon"><i className={`ti ${c.icon}`} /></div>
                <div>
                  <div className="ccard-label">{c.label}</div>
                  <div className="ccard-value">{c.val}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="copy-row">
            <button className={`copy-btn ${copied === 'email' ? 'done' : ''}`} onClick={() => copy('vikramrajavc@gmail.com','email')}>
              <i className={`ti ${copied === 'email' ? 'ti-check' : 'ti-copy'}`} />
              {copied === 'email' ? 'Copied!' : 'Copy email'}
            </button>
            <button className={`copy-btn ${copied === 'phone' ? 'done' : ''}`} onClick={() => copy('+91 87606 36511','phone')}>
              <i className={`ti ${copied === 'phone' ? 'ti-check' : 'ti-copy'}`} />
              {copied === 'phone' ? 'Copied!' : 'Copy phone'}
            </button>
          </div>
        </div>

        <div className="contact-right">
          <div className="form-row-2">
            <div className="form-group">
              <label className="form-label">Name</label>
              <input className="finput" type="text" placeholder="Your name" />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="finput" type="email" placeholder="your@email.com" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Subject</label>
            <input className="finput" type="text" placeholder="Project enquiry / Job opportunity / Just saying hi" />
          </div>
          <div className="form-group">
            <label className="form-label">Message</label>
            <textarea className="finput" rows={5} placeholder="Tell me about your project, role, or idea..." />
          </div>
          <button className="btn-primary send-btn">
            <i className="ti ti-send" /> Send Message
          </button>
        </div>
      </div>

      <div className="footer-divider" />
      <footer className="footer">
        <div className="footer-left">
          <span className="footer-name">Vikram</span>
          <span className="footer-sub">Audiowide + Raleway · Dark/Light · .NET · Angular · Azure</span>
        </div>
        <div className="social-row">
          {[
            { icon: 'ti-brand-linkedin', label: 'LinkedIn' },
            { icon: 'ti-brand-github',   label: 'GitHub' },
            { icon: 'ti-mail',           label: 'Email' },
            { icon: 'ti-download',       label: 'Download CV' },
          ].map(s => (
            <button key={s.label} className="social-btn" title={s.label}>
              <i className={`ti ${s.icon}`} />
            </button>
          ))}
        </div>
      </footer>
    </section>
  );
}
